import { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import GameCard from '../shared/GameCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faStar,
  faBullseye,
  faPen,
  faPuzzlePiece,
} from '@fortawesome/free-solid-svg-icons';
import { getSubscriber } from '../../apiservices/LocalStorageService';
import { fetchMyGames } from '../../apiservices/axiosservice/subscriberservice';
import './styles/RecentGames.css';
import { gamePlayStatus } from '../../util/common';

const gameTypeConfig: Record<
  string,
  { icon: React.ReactNode; color: string; category: string }
> = {
  quiz: {
    icon: <FontAwesomeIcon icon={faStar} />,
    color: 'var(--color-card-teal)',
    category: 'Smart Quiz',
  },
  geoplay: {
    icon: <FontAwesomeIcon icon={faBullseye} />,
    color: 'var(--color-primary)',
    category: 'Geo Guess',
  },
  sketcher: {
    icon: <FontAwesomeIcon icon={faPuzzlePiece} />,
    color: 'var(--color-card-brown)',
    category: 'Drawing',
  },
};

const mockGames = [];

const RecentGames: React.FC = () => {
  const [games, setGames] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const loadGames = useCallback(async () => {
    try {
      const user = getSubscriber();
      if (!user?.userId) return;
      const res = await fetchMyGames({
        gameOwnerId: user.userId,
        page: 1,
        limit: 4,
      });
      if (res.data.games?.length) setGames(res.data.games);
      else setGames(mockGames);
    } catch {
      setGames(mockGames);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadGames();
  }, [loadGames]);

  const getConfig = (type: string) =>
    gameTypeConfig[type] || gameTypeConfig.quiz;

  if (loading) return <p className="recent-games__loading">Loading games...</p>;

  return (
    <section className="recent-games">
      <div className="recent-games__header">
        <h3 className="recent-games__title">Recent Games</h3>
        <button
          className="recent-games__see-all"
          onClick={() => navigate('/dashboard/games')}
        >
          See All →
        </button>
      </div>
      {games.length === 0 ? (
        <p className="recent-games__empty">
          No games yet. Create your first one!
        </p>
      ) : (
        <div className="recent-games__grid">
          {games.map((g) => {
            const cfg = getConfig(g.gameType);
            return (
              <GameCard
                key={g.gameId}
                title={g.gameTitle}
                category={cfg.category}
                status={gamePlayStatus(g.status)}
                plays={g.currentPlayer || 0}
                icon={cfg.icon}
                bgColor={cfg.color}
                onClick={() => navigate(`/dashboard/games/game/${g.gameId}`)}
              />
            );
          })}
        </div>
      )}
    </section>
  );
};

export default RecentGames;
